import {
    Box,
    Button,
    FormControl,
    Grid,
    IconButton,
    InputAdornment,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Select,
    TextField,
} from "@mui/material";
import { ErrorMessage, Form, Formik } from "formik";
import React, { useState } from "react";
import Images from "../../assets";
import { useAppDispatch, useAppSelector } from "../../assets/hooks";
import * as Yup from "yup";
import { Check, Visibility, VisibilityOff } from "@mui/icons-material";
import {
    countryList,
} from "../../assets/menu";
import { TEAM_ROLE_OPTIONS } from "../../assets/enums";
import { secondaryButton } from "../../components/styles/customStyles";
import { createTeam } from "../../services";
import { closePopup } from "../../store/slices/popupSlice";

const CreateTeam = () => {
    const dispatch = useAppDispatch();
    const [showPassword, setShowPassword] = useState(false);
    const [showCPassword, setShowCPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    const toggleCPasswordVisibility = () => {
        setShowCPassword(!showCPassword);
    };

    const initValues = {
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        cPassword: "",
        expertiseCountry: [] as string[],
        role: "",

    };

    const signInSchema: Yup.ObjectSchema<any> = Yup.object().shape({
        firstName: Yup.string()
            .required("Required")
            .matches(/^[a-zA-Z\s]*$/, "Name should only contain letters and spaces"),
        lastName: Yup.string()
            .required("Required")
            .matches(/^[a-zA-Z\s]*$/, "Name should only contain letters "),
        password: Yup.string()
            .min(3, "Too Short!")
            .max(25, "Too Long!")
            .required("Password is required")
            .matches(
                /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                "Password must have 1 uppercase, 1 number, 1 special character, and be at least 8 characters long"
            ),
        cPassword: Yup.string()
            .oneOf([Yup.ref("password")], "Password must match!")
            .required("Confirm password is required!"),
        email: Yup.string()
            .matches(
                /([a-z0-9]+)([{1}])?([a-zA-Z0-9]+)([a-zA-Z0-9]+)([a-z]+)/g,
                "Enter Email Id"
            )
            .required("Enter Email ID")
            .max(40, "Email ID must be at most 40 characters"),
        expertiseCountry: Yup.array()
            .of(Yup.string())
            .min(1, "At least one expertiseCountry is required"),
        role: Yup.string().required("Please select a role"),

    });


    const onSubmitForm = async (values: any) => {
        setLoading(true)
        let data = {
            firstName: values.firstName,
            lastName: values.lastName,
            email: values.email,
            password: values.password,
            expertiseCountry: values.expertiseCountry,
            role: values.role,
        }
          const response = await createTeam(data);
          if (response.data.success) {
            setLoading(false)
            dispatch(closePopup())
          } else {
            setLoading(false)
          }
    };

    return (
        <Box sx={{ height: "100%" }}>
            <Grid container sx={{ height: "100%" }}>
                <Grid item xs={12} sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                    <Box sx={{ px: { xs: 2 } }}>
                        <Formik
                            initialValues={initValues}
                            validationSchema={signInSchema}
                            onSubmit={(values: any) => onSubmitForm(values)}
                            enableReinitialize={true}
                        >
                            {({ errors, values, handleChange, touched, setFieldValue }) => {
                                return (
                                    <Form>
                                        <Grid container spacing={2} sx={{ mt: 2, overflow: "auto" }} >
                                            <Grid item xs={12} md={6}>
                                                <TextField
                                                    id="firstName"
                                                    name="firstName"
                                                    type="text"
                                                    size="small"
                                                    placeholder="First name *"
                                                    value={values.firstName}
                                                    onChange={handleChange}
                                                    fullWidth
                                                    label="First name *"
                                                    error={touched.firstName && Boolean(errors.firstName)}
                                                />
                                                <div style={{ color: "#d32f2f", fontSize: "12px" }}>
                                                    <ErrorMessage name="firstName" component="div" />
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <TextField
                                                    id="lastName"
                                                    name="lastName"
                                                    type="text"
                                                    size="small"
                                                    label="Last name *"

                                                    placeholder="Last name *"
                                                    value={values.lastName}
                                                    onChange={handleChange}
                                                    fullWidth
                                                    error={touched.lastName && Boolean(errors.lastName)}
                                                />
                                                <div style={{ color: "#d32f2f", fontSize: "12px" }}>
                                                    <ErrorMessage name="lastName" component="div" />
                                                </div>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    id="email"
                                                    name="email"
                                                    type="email"
                                                    placeholder="Email *"
                                                    label="Email *"

                                                    value={values.email}
                                                    onChange={handleChange}
                                                    fullWidth
                                                    error={touched.email && Boolean(errors.email)}
                                                    size="small"
                                                />
                                                <div style={{ color: "#d32f2f", fontSize: "12px" }}>
                                                    <ErrorMessage name="email" component="div" />
                                                </div>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    id="password"
                                                    name="password"
                                                    size="small"
                                                    label="Password *"

                                                    type={showPassword ? "text" : "password"}
                                                    placeholder="Password *"
                                                    value={values.password}
                                                    onChange={handleChange}
                                                    error={touched.password && Boolean(errors.password)}
                                                    // helperText={touched.password && errors.password}
                                                    sx={{
                                                        "&::placeholder": {
                                                            color: "#000 !important"
                                                        },
                                                        '& .MuiOutlinedInput-root .Mui-error': {
                                                            '& fieldset': {
                                                                borderColor: 'red',
                                                            },
                                                        },
                                                    }}
                                                    fullWidth
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <IconButton
                                                                    edge="end"
                                                                    onClick={togglePasswordVisibility}
                                                                    sx={{
                                                                        position: "absolute",
                                                                        right: "20px",
                                                                        zIndex: 1,
                                                                        background: "#fff",
                                                                        "& .MuiSvgIcon-root ": {
                                                                            fontSize: "1.3rem"
                                                                        }
                                                                    }}
                                                                >
                                                                    {showPassword ? <Visibility /> : <VisibilityOff />}
                                                                </IconButton>
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                                <div style={{ color: "#d32f2f", fontSize: "12px" }}>
                                                    <ErrorMessage name="password" component="div" />
                                                </div>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    id="cPassword"
                                                    name="cPassword"
                                                    size="small"
                                                    label="Confirm password  *"

                                                    type={showCPassword ? "text" : "password"}
                                                    placeholder="Confirm password *"
                                                    value={values.cPassword}
                                                    onChange={handleChange}
                                                    fullWidth
                                                    error={touched.cPassword && Boolean(errors.cPassword)}
                                                    // helperText={touched.cPassword && errors.cPassword}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <IconButton
                                                                    edge="end"
                                                                    onClick={toggleCPasswordVisibility}
                                                                    sx={{
                                                                        position: "absolute",
                                                                        right: "20px",
                                                                        zIndex: 1,
                                                                        background: "#fff",
                                                                        "& .MuiSvgIcon-root ": {
                                                                            fontSize: "1.3rem"
                                                                        }
                                                                    }}
                                                                >
                                                                    {showCPassword ? <Visibility /> : <VisibilityOff />}
                                                                </IconButton>
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                                <div style={{ color: "#d32f2f", fontSize: "12px" }}>
                                                    <ErrorMessage name="cPassword" component="div" />
                                                </div>

                                            </Grid>
                                            <Grid item xs={12}>
                                                <FormControl sx={{ width: "100%" }}>
                                                    <InputLabel id="expertiseCountry-label">Expertise Countries *</InputLabel>
                                                    <Select
                                                        id="expertiseCountry"
                                                        size="small"
                                                        name="expertiseCountry"
                                                        value={values.expertiseCountry}
                                                        onChange={handleChange}
                                                        fullWidth
                                                        multiple
                                                        labelId="expertiseCountry-label"  // Connect the label to the select
                                                        input={<OutlinedInput label="Expertise Countries *" />}  // Attach label to OutlinedInput
                                                        error={touched.expertiseCountry && Boolean(errors.expertiseCountry)}
                                                        renderValue={(selected: unknown) => {
                                                            const selectedArray = selected as string[];
                                                            return selectedArray.join(", "); // Show selected countries
                                                        }}
                                                        sx={{
                                                            padding: "4px 8px",
                                                        }}
                                                    >
                                                        {countryList.map((name: string) => (
                                                            <MenuItem
                                                                key={name}
                                                                value={name}
                                                                sx={{
                                                                    "& .MuiTypography-root": {
                                                                        fontSize: "14px !important",
                                                                    },
                                                                    "& .MuiSvgIcon-root": {
                                                                        fontSize: "1rem",
                                                                    },
                                                                    whiteSpace: "normal",
                                                                }}
                                                            >
                                                                {name}
                                                                {values.expertiseCountry?.includes(name) && (
                                                                    <Check sx={{ marginLeft: "auto", fontSize: "1rem" }} />
                                                                )}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>

                                                <div style={{ color: "#d32f2f", fontSize: "12px" }}>
                                                    <ErrorMessage name="expertiseCountry" component="div" />
                                                </div>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Select
                                                    id="language"
                                                    size="small"
                                                    name="role"
                                                    displayEmpty
                                                    defaultValue=""
                                                    value={values.role}
                                                    onChange={handleChange}
                                                    fullWidth
                                                    // IconComponent={ExpandMoreIcon}
                                                    error={touched.role && Boolean(errors.role)}
                                                // helperText={touched.role && errors.role}
                                                >
                                                    <MenuItem
                                                        disabled
                                                        value=""
                                                        sx={{
                                                            "& .MuiTypography-root": {
                                                                fontSize: "14px !important",
                                                            },
                                                        }}
                                                    >
                                                        Preferred role *
                                                    </MenuItem>

                                                    {TEAM_ROLE_OPTIONS.map((name) => (
                                                            <MenuItem
                                                                key={name}
                                                                value={name}
                                                                sx={{
                                                                    "& .MuiTypography-root": {
                                                                        fontSize: "14px !important",
                                                                    },
                                                                    "& .MuiSvgIcon-root ": {
                                                                        fontSize: "1rem",
                                                                    },
                                                                    whiteSpace: "normal",
                                                                }}
                                                            >
                                                                {name}
                                                            </MenuItem>
                                                        ))}
                                                </Select>
                                                <div style={{ color: "#d32f2f", fontSize: "12px" }}>
                                                    <ErrorMessage name="role" component="div" />
                                                </div>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", mt: 1 }}>
                                                <Button
                                                    sx={[secondaryButton, { width: "100px" }]}
                                                    type="submit"
                                                    // onClick={onSubmitForm}
                                                >
                                                    {loading ? (
                                                        <img
                                                            src={Images.standardLoader}
                                                            alt="load"
                                                            style={{
                                                                width: "20px",
                                                                height: "20px",
                                                                padding: "5px",
                                                            }}
                                                        />
                                                    ) : (
                                                        "Submit"
                                                    )}

                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Form>
                                )
                            }
                            }
                        </Formik>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default CreateTeam;
